// extracted by mini-css-extract-plugin
export default {"content":"_ba3859a0"};